import { render, staticRenderFns } from "./categoryAdmin.vue?vue&type=template&id=1b1c2690&"
import script from "./categoryAdmin.vue?vue&type=script&lang=js&"
export * from "./categoryAdmin.vue?vue&type=script&lang=js&"
import style0 from "./categoryAdmin.vue?vue&type=style&index=0&id=1b1c2690&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports